module.exports = __webpack_public_path__ + "static/media/Omanyte_gaussian2.8642802b.png";